{
  "title": "Asignar a un hogar",
  "body": "El {{objectType}} se asociará con el hogar, siendo el usuario el contacto principal.",
  "householdTitle": "Hogar",
  "name": "Nombre",
  "modal": {
    "title": " Asignar a un hogar"
  }
}
